//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import CFooter from "@/common/Footer";
	export default {
		data() {
			return {
        tabs:[
          {
            label:'云服务器',
            name:'server'
          },
          {
            label:'虚拟主机',
            name:'vhost'
          },
          {
            label:'域名',
            name:'domain'
          },
          {
            label:'免费空间',
            name:'free'
          }],
        tabIndex:0
			}
		},
		mounted() {
      switch(this.$route.params.name)
      {
        case 'server':
          this.tabIndex = 0
          break;
        case 'vhost':
          this.tabIndex = 1
          break;
        case 'domain':
          this.tabIndex = 2
          break;
        case 'free':
          this.tabIndex = 3
          break;
      }
		},
    watch:{
      '$route.params.name' (val) {
        switch(val)
        {
          case 'server':
            this.tabIndex = 0
            break;
          case 'vhost':
            this.tabIndex = 1
            break;
          case 'domain':
            this.tabIndex = 2
            break;
          case 'free':
            this.tabIndex = 3
            break;
        }
      }
    },
		methods: {

		},
		components: {
			CFooter
		}
	}



// WEBPACK FOOTER //
// ./src/components/product/menu.vue